<div class="rp-status" [ngClass]="type()">{{ label() }}</div>
